import { DropdownOption } from "../models/ui/dropdownOption";

export const WIKI_ACCESS_LEVEL_OPTIONS: DropdownOption[] = [
  {
    label: "wiki.access_levels.lite",
    value: "LITE",
  },
  {
    label: "wiki.access_levels.expert",
    value: "EXPERT",
  },
];
